export function validateDiscountPercentageIsInvalid(percentage: string): boolean {
  const MIN = 0;
  const MAX = 100;
  const value = Number(percentage);

  const invalid = [!value, value < MIN, value > MAX].some(Boolean);

  return invalid;
}
